import React, { useEffect, useRef, useState } from "react";
import CaretDown from "../../../assets/svg/icons/common/CaretDown";
import DarkCross from "../../../assets/svg/icons/common/dark-cross";
import SearchIcon from "../../../assets/svg/icons/common/search";
import TextInput from "../text-input";
import formBaseStyles from "../text-input/styles.module.scss";
import styles from "./styles.module.scss";

const Option = ({ children, option, handleOptionSelect }) => {
  if (!handleOptionSelect) {
    return (
      <div
        className={`${styles.option} ${!handleOptionSelect && styles.optionNoSelect}`}
      >
        {children}
      </div>
    );
  }

  return (
    <div
      tabIndex={0}
      className={`${styles.option}`}
      onClick={() => handleOptionSelect(option)}
      onKeyUp={(e) => e.key === "Enter" && handleOptionSelect(option)}
    >
      {children}
    </div>
  );
};

export const TagInput = ({
  id,
  label,
  placeholder,
  value,
  options,
  onChange,
  hideChips = false,
  touched = false,
  errored = false,
  error = "",
}) => {
  const selectContainerRef = useRef(null);
  const [selected, setSelected] = useState(value);
  const [searchTerm, setSearchTerm] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleOptionSelect = (option) => {
    if (selected && selected?.some((s) => s.value === option.value)) {
      return;
    }

    setSelected((prev) => [...prev, option]);
    onChange([...selected, option]);
    setDropdownOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        selectContainerRef.current &&
        !selectContainerRef.current.contains(e.target)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!dropdownOpen) {
      setSearchTerm("");
    }
  }, [dropdownOpen]);

  useEffect(() => {
    setSelected(value || []);
  }, [value]);

  return (
    <div>
      <label className={formBaseStyles.label} htmlFor={id}>
        {label}
      </label>
      <div className={`${styles.selectContainer}`} ref={selectContainerRef}>
        <TextInput
          type="text"
          placeholder={placeholder || "Search..."}
          prefix={<SearchIcon />}
          suffix={
            <div className={`${styles.caret} ${dropdownOpen && styles.open}`}>
              <CaretDown />
            </div>
          }
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onClick={() => setDropdownOpen(!dropdownOpen)}
        />
        <div
          className={`${styles.dropdownContainer} ${dropdownOpen && styles.open}`}
        >
          <div className={`${styles.dropdown}`}>
            {options &&
              options
                .filter(
                  (option) => !selected?.some((s) => s.value === option.value),
                )
                .filter((option) =>
                  option.label.toLowerCase().includes(searchTerm.toLowerCase()),
                )
                .map((option) => (
                  <Option
                    key={option.value}
                    option={option}
                    handleOptionSelect={handleOptionSelect}
                  >
                    {option.label}
                  </Option>
                ))}

            {options &&
              options.filter((option) =>
                option.label.toLowerCase().includes(searchTerm.toLowerCase()),
              ).length === 0 &&
              searchTerm.length > 0 && <Option>No results found</Option>}
          </div>
        </div>
        {touched && errored && error && <p className={styles.error}>{error}</p>}
      </div>

      {!hideChips && selected && selected.length > 0 && (
        <div className={styles.selectedOptions}>
          {selected.map((option) => (
            <div className={styles.selectedOption} key={option.value}>
              {option.label}

              <span
                className={styles.removeSelectedOption}
                onClick={() => {
                  setSelected((prev) =>
                    prev.filter((sel) => sel.value !== option.value),
                  );
                  onChange(
                    selected.filter((sel) => sel.value !== option.value),
                  );
                }}
              >
                <DarkCross />
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TagInput;
